
import Location from './Location'

import { isObject } from '@/services/validation'
// import { capitalize } from '@/helpers/string'

import AmsterdamRealisation from '@/models/amsterdam/Realisation'
import PNCRealisation from '@/models/park-n-charge/Realisation'
import GORRealisation from '@/models/go-ral/Realisation'
import OPCRealisation from '@/models/opcharge/Realisation'
import RVBRealisation from '@/models/rvb/Realisation'
import VLARealisation from '@/models/vlaanderen/Realisation'

const leadingZero = (num) => `0${num}`.slice(-2)

// let currentYear = (new Date()).getFullYear()
const formatTime = (date) =>
  [date.getHours(), date.getMinutes()] // , date.getSeconds()
  .map(leadingZero)
  .join(':')


/******************************************************************************
 * Constructors
 */
const RealisationByTenent = {
  'amsterdam': AmsterdamRealisation,
  'park-n-charge': PNCRealisation,
  'go-ral': GORRealisation,
  'opcharge': OPCRealisation,
  'rvb': RVBRealisation,
  'vlaanderen': VLARealisation,
}

const Realisation = RealisationByTenent[process.env.VUE_APP_TENANT] || function() {}

/******************************************************************************
 * Shared methods
 */
Realisation.prototype.getRef = function() {
  return this.ref || null
}
Realisation.prototype.getUuid = function() {
  return this.uuid || null
}
Realisation.prototype.getSyncedTS = function() {
  return this.ts || null
}
Realisation.prototype.isUnsavedRecord = function() {
  return this.ts === null
}
Realisation.prototype.getModelName = function() {
  return 'Realisation'
}
Realisation.prototype.setTags = function({ Tags }) {
  this.Tags = Tags
}
Realisation.prototype.hasTags = function() {
  return !! (Array.isArray(this.Tags) && this.Tags.length !== 0)
}
Realisation.prototype.getTags = function() {
  return Array.isArray(this.Tags) ? this.Tags : []
}
Realisation.prototype.getTagLabels = function () {
  const tenantTags = this.$store.getters['tenant/getTags']
  const tags = this.getTags() || []
  const tagLabels = tags.map(tag => tenantTags.find(t => t.uuid === tag)?.label)

  return tagLabels
}
Realisation.prototype.getCaseRef = function() {
  return this.case_ref
}
Realisation.prototype.getCurrentIterationCaseData = function() {
  return this.values.Location
}
// Naming is no longer acurate
// Realisation.prototype.getLocation = function() {
//   return this.values.Location
// }
Realisation.prototype.hasDocOfType = function({ doctype }) {
  return Array.isArray(this.Docs[doctype]) && this.Docs[doctype].length !== 0
}
Realisation.prototype.getNextDocTypeId = function({ doctype }) {
  let ids = (this.Docs[doctype] || []).map(doc => {
    return (isObject(doc)) ? doc.id : doc
  })
  return ids.length ? Math.max(...ids) + 1 : 1
}
Realisation.prototype.nextLocationVersion = function() {
  // console.log(this.history)
  return Math.max(...this.history.map(location => location.version)) + 1
}

/******************************************************************************
 * Process Type
 */
Realisation.prototype.setProcessType = function({ processType }) {
  this.processType = processType
}
Realisation.prototype.getProcessType = function() {
  return this.processType || null
}
Realisation.prototype.hasProcessType = function() {
  return this.getProcessType() !== null
}
Realisation.prototype.getProcessTypeLabel = function() {
  return this.$store.getters['tenant/getSelectOptionLabelByValue']({
    name: 'processtypes',
    value: this.processType,
  }) || ''
}

/******************************************************************************
 * Geography
 */

Realisation.prototype.getGeographyCode = function() {
  return this.geographyCode || this.MunicipalityCode
}

Realisation.prototype.setGeographyCode = function({ code }) {
  this.geographyCode = this.Municipality = this.MunicipalityCode = code
}


/******************************************************************************
 * Stakeholders
 */

Realisation.prototype.getStakeholders = function() {
  return this.stakeholders || []
}

Realisation.prototype.getStakeholderSlugByCategory = function({ category }) {
  category = category + '|'
  let stakeholder = (this.stakeholders || []).find(stakeholder => stakeholder.startsWith(category))
  return stakeholder ? stakeholder : null
}



/******************************************************************************
 * Events
 */
Realisation.prototype.calculateStepDuractions = function({ Events, case_ref }) {
  //let debug = false

  if (case_ref === 'GOR-RP-22-74') {
    //console.log("calc", case_ref, Events)
    //debug = true
  }


  return Events.reduce((durations, Event) => {

    //if (debug) console.log(durations)
    //if (debug) console.log(Event)

    if (Event.type === 'step-start') {
      //if (debug) console.log("start")

      let uuid = Event?.meta?.uuid || null
      if (uuid !== null) {
        let current = durations[uuid] || false

        //if (debug) console.log(current)

        // Create a new entry if there is no current data,
        // or if the start is after the currently registered end
        if (! current || Event.ts > current.end) {

          //if (debug) console.log("no current / ts greater than to current end")

          durations[uuid] = {
            start: Math.max(durations[uuid]?.start || 0, Event.ts),
            end: 0,
            finished: false,
          }
        } else {

          //if (debug) console.log("current and ts equal or lower than current end")

          durations[uuid].start = Math.max(durations[uuid].start, Event.ts)
        }
      }
    } else if (Event.type === 'step-end') {

      //if (debug) console.log('end')

      let uuid = Event?.meta?.uuid || null
      if (uuid !== null) {
        let current = durations[uuid] || false

        //if (debug) console.log(current)

        // If there already an entry...
        if (current) {
          // Only accept end dates after or equal to the registred start date
          if (current.start <= Event.ts) {

            //if (debug) console.log("start is equal to or after end")

            // Always register the latest end date
            durations[uuid].end = Math.max(durations[uuid].end, Event.ts)
            durations[uuid].finished = true
          } else {
            //if (debug) console.log("ignore")
          }
        } else {
          //if (debug) console.log("set or replace")

          durations[uuid] = {
            start: 0,
            end: Event.ts,
            finished: true,
          }
        }
      }
    }

    //if (debug) console.log(durations)

    return durations
  }, {})
}

/**
 * TODO: CBAPI - DEFERRED - Store state by uuid instead in array format
 */
Realisation.prototype.CBAPIcalculateStepDuractions = function({ flowState }) {
  return flowState.reduce((acc, step) => {
    acc[step.uuid] = {
      start: step.started_at,
      end: step.completed_at,
      finished: !! step.completed_at
    }
    return acc
  }, {})
}

Realisation.prototype.getStepDuractionByUuid = function({ uuid }) {
  return this.processDurationByStep[uuid] || {
    start: 0,
    end: 0,
    finished: false,
  }
}

Realisation.prototype.getCurrentStepDuraction = function() {
  const currentFlowStatus = this.getCurrentFlowStatus()
  if (! currentFlowStatus || ! currentFlowStatus.uuid) {
    return {
      start: 0,
      end: 0,
      finished: false
    }
  }
  return this.getStepDuractionByUuid({
    uuid: currentFlowStatus.uuid,
  })
}

Realisation.prototype.getCurrentStepUuid = function() {
  return this.getCurrentFlowStatus()?.uuid || null
}

Realisation.prototype.getCurrentStepShort = function() {
  return this.getCurrentFlowStatus()?.short || null
}

/******************************************************************************
 * Location connection methods
 */

Realisation.prototype.hasConnectedLocation = function({ category }) {
  return !! this.connectedLocations[category]
}

Realisation.prototype.getConnectedLocationUuid = function({ category } = { category: 'selected' }) {
  return this.connectedLocations?.[category]?.locationUuid || null
}


/******************************************************************************
 * Data formatting at contruction that is shared between all tenants
 */

if (! Realisation.prototype.generateSearchData) {
  Realisation.prototype.generateSearchData = () => {
    return {}
  }
}
if (! Realisation.prototype.generateAddressData) {
  Realisation.prototype.generateAddressData = () => {
    return ''
  }
}
if (! Realisation.prototype.generateMunicipalityData) {
  Realisation.prototype.generateMunicipalityData = ({ data }) => {
    return data.geographyCode || data.MunicipalityCode || data.Municipality || null
  }
}

if (! Realisation.prototype.getFlowUuid) {
  Realisation.prototype.getFlowUuid = function(){
    return this.flow && this.flow.uuid ? this.flow.uuid : false
  }
}

if (! Realisation.prototype.statusByFlow) {
  Realisation.prototype.statusByFlow = function({ flow }) {

    if (this.cbapi) {
      return this.CBAPIstatusByFlow({ flow })
    }

    console.log("StatusByFlow", this.cbapi)

    if (!Array.isArray(flow?.state)) return
    let steps = this.$store.getters['tenant/getWorkflowSpecByName']({
      name: 'realisation',
    })?.steps || []

    // most recently started step that has not been completed
    const state = Array.isArray(flow.state) ?  flow.state : []
    let uuid = state
      .filter(step => !step.completed_at)
      .sort((a, b) => a.started_at - b.started_at)
      .map(step => step.uuid)
      .shift()

    // There was no uncompleted step. Perhaps the process was completed.
    if (! uuid) {

      // Something could have gone horribly wrong with the flow state
      if (flow.state.length === 0) {
        return {
          step: 1,
          label: 'Onbekend',
        }
      }

      // Was the final step completed?
      let final = steps.find(step => step.final === true)
      if (final && state.find(step => step.uuid === final.uuid)) {
        return {
          step: final.step || final.short,
          uuid: final.uuid,
          version: final.version,
          label: 'Afgerond',
        }
      }

      // If not, return the details of the step that was completed last
      uuid = state
        .filter(step => step.completed_at)
        .sort((a, b) => {
          // Note the assumption that the later step in the flow follows after the former
          return  b.completed_at === a.completed_at ? -1 : b.completed_at - a.completed_at
        })[0].uuid || null
    }

    let step = steps.find(step => step.uuid === uuid)
    if (! step) {

      // Perhaps we got a case of mixed flows?
      return {
        step: 1,
        label: 'Onbekend',
      }
    }

    return {
      step: step.step || step.short,
      uuid: step.uuid,
      version: step.version,
      label: step.label,
    }
  }
}

if (! Realisation.prototype.CBAPIstatusByFlow) {
  Realisation.prototype.CBAPIstatusByFlow = function({ flow }) {

    const WorkflowSpecification = this.$store.getters['tenant/getWorkflowSpecByUuid']({
      uuid: flow.uuid,
    })

    const steps = WorkflowSpecification?.steps || []

    // TODO: DEN HARTOG - Handle missing spec
    if (steps.length === 0) {
      throw new Error("missing flow specification")
    }

    let activeStepUuid = flow?.activeStep?.uuid || null

    // TODO: CBAPI - TEST - Will this cause problems during step 1 while creating a new process record?
    // TODO: CBAPI - TEST - Does a completed process have an active step ?
    // TODO: CBAPI - TEST - Does this cause issues for processes that are cancelled or on-hold?  
    if (activeStepUuid === null) {

      if (flow.state.length === 1) {
        let step = WorkflowSpecification.stepsByUuid[flow.state[0].uuid]
        return {
          step: step.short,
          uuid: step.uuid,
          version: flow.iteration,
          label: step.label,
        }
      }

      // Has the final process step been completed ?
      const finalStepUuid = WorkflowSpecification.finalStepUuid
      if (finalStepUuid && flow.state.find(step => step.uuid === finalStepUuid)) {
        let step = WorkflowSpecification.stepsByUuid[finalStepUuid]

        return {
          step: step.short,
          uuid: finalStepUuid,
          version: flow.iteration,
          label: 'Afgerond',
        }
      }
      
      throw new Error("missing information regarding active step")
    }

    let step = WorkflowSpecification.stepsByUuid[activeStepUuid]
    return {
      step: step.short,
      uuid: activeStepUuid,
      version: flow.iteration,
      label: step.label,
    }
  }
}

if (! Realisation.prototype.getCurrentFlowStatus) {
  Realisation.prototype.getCurrentFlowStatus = function(){
    return this.statusByFlow({
      flow: this.flow,
    })
  }
}
if (! Realisation.prototype.getWorkflowSpecificationUuid) {
  Realisation.prototype.getWorkflowSpecificationUuid = function() {
    return this.flow?.uuid
  }
}

if (! Realisation.prototype.orderAvailableFlowSteps) {
  Realisation.prototype.orderAvailableFlowSteps = function() {
    return this.flow.state.filter(state => state.started_at).sort((a, b) => a.started_at - b.started_at)
  }
}
if (! Realisation.prototype.nextAvailableFlowStep) {
  Realisation.prototype.nextAvailableFlowStep = function({ currentUuid }) {
    let order = this.orderAvailableFlowSteps()
    // console.log("order", order)
    let index = order.findIndex(state => state.uuid === currentUuid)
    return order[index + 1] ? order[index + 1] : order[0]
  }
}
if (! Realisation.prototype.previousAvailableFlowStep) {
  Realisation.prototype.previousAvailableFlowStep = function({ currentUuid }) {
    let order = this.orderAvailableFlowSteps()
    let index = order.findIndex(state => state.uuid === currentUuid)
    return order[index - 1] ? order[index - 1] : order[0]
  }
}
if (! Realisation.prototype.getCurrentIteration) {
  Realisation.prototype.getCurrentIteration = function() {
    return this.flow?.iteration || 1
  }
}

if (! Realisation.prototype.commonStructure) {
  Realisation.prototype.commonStructure = function({ ref, data }) {

    let model = {}

    // console.log("new Location", ref, data)

    let updated_at = 'Onbekend'
    let updated_at_short = ''
    let updated_at_nr = data.updated_at || 0
    if (data.updated_at) {

      let recordDate = new Date(data.updated_at)
      // es-CL = DD-MM-YYYY
      updated_at = `${recordDate.toLocaleDateString('es-CL')} ${formatTime(recordDate)}`

      // old data
      updated_at_short = {
        date: recordDate.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: '2-digit' }).replace('. ', ' \''),
        time: formatTime(recordDate),
      }
      // if (currentYear > recordDate.getFullYear()) {
      //   updated_at_short = recordDate.toLocaleDateString("nl-NL", { day: 'numeric', month: 'short', year: 'numeric' })
      // } else {

      // }
    }
    // console.log(data.Locations)
    // The first Location is the current Location
    const CurrentLocation = data.Locations?.length ? data.Locations[0] : {}

    try {
      let status = data.status ? data.status : null

      // Fallback...
      if (status === null) {
        let steps = this.$store.getters['tenant/getWorkflowSpecByName']({
          name: 'realisation',
        })?.steps || []

        status = {
          step: steps[0].short || steps[0].step,
          uuid: steps[0].uuid,
          version: steps[0].version,
          label: steps[0].label,
          completed: false,
          cancelled: false,
          onhold: false,
          vkb: false,
        }
      }

      // Go by process flow
      if (data.flow) {
        // console.log("flow available... !", data.flow, ref)

        status = Object.assign(
          status,
          this.statusByFlow({ flow: data.flow }),
        )
        // console.log(status)
      }

      let statusMetaDefaults = {
        onhold: {
          reason: '',
          label: '',
          comment: '',
        },
        cancelled: {
          reason: '',
          label: '',
          comment: '',
        },
        onholdReason: '',
        onholdLabel: '',
        onholdComment: '',
        cancelledReason: '',
        cancelledLabel: '',
        cancelledComment: '',
      }
      let statusMeta = statusMetaDefaults

      if (data.statusMeta) {
        statusMeta = Object.assign(statusMetaDefaults, data.statusMeta)
      }
      if (CurrentLocation) {
        //console.log(data)
        CurrentLocation.Municipality = data.MunicipalityCode || data.Municipality || null
        CurrentLocation.MunicipalityCode = CurrentLocation.Municipality
      }


      model = {
        cbapi: false,
        ref: ref,
        uuid: data.uuid,
        ts: data.ts || null,
        processType: data.processType || null,

        raw: JSON.parse(JSON.stringify(data)),

        case_ref: data.case?.full || '',
        case_counter: data.caseNumber || 0,

        status,
        statusMeta,

        /**
         * Step 1 only for now
         */
        values: {
          Location: CurrentLocation ? new Location({ data: CurrentLocation }) : new Location({ data: {} }),
        },

        CurrentLocation,

        history: data.Locations ? data.Locations.map(data => new Location({ data })) : [],

        Docs: data.Docs ? {
          ParkingSpots: data.Docs.ParkingSpots || [],
          Underground: data.Docs.Underground || [],
          Broker: data.Docs.Broker || [],
          GridOperator: data.Docs.GridOperator || [],
          CPOAdditional: data.Docs.CPOAdditional || [],
          TrafficDecision: data.Docs.TrafficDecision || [],
          DeliveryDocumentation: data.Docs.DeliveryDocumentation || [],
          SideView: data.Docs.SideView || [],
          TopView: data.Docs.TopView || [],
        } : {
          ParkingSpots: [],
          Underground: [],
          Broker: [],
          GridOperator: [],
          CPOAdditional: [],
          TrafficDecision: [],
          DeliveryDocumentation: [],
          SideView: [],
          TopView: [],
        },

        /**
         * Connected requests
         */
        requestUuids: data.requestUuids || [],
        relationalChanges: {
          removed: [],
          added: [],
        },


        /**
         * Tags
         */
        Tags: data.Tags || [],

        /**
         * TODO: Remarks etc.
         */
        Events: data.Events || [],

        /**
         * Calculated based on events
         */
        processDurationByStep: {},

        /**
         * Comments
         */
        comments: data.comments || [],

        /**
         * The process flow information
         */
        flow: data.flow || null,

        updated_at,
        updated_at_short,
        updated_at_nr,
      }
      //console.log(model.values)
      model.processDurationByStep = this.calculateStepDuractions({ Events: model.Events, case_ref: model.case_ref })


      model.Municipality = this.generateMunicipalityData({ model, data })
      model.MunicipalityCode = model.Municipality
      model.address = this.generateAddressData({ model, data })
      model.search = this.generateSearchData({ model, data })

    } catch (e) {
      console.log(e)
      console.log('Failed to construct data model')

    }

    return model
  }
}

if (! Realisation.prototype.commonCBAPIStructure) {
  Realisation.prototype.commonCBAPIStructure = function({ data }) {

    let model = {}

    // console.log("new Location", ref, data)

    let updated_at = 'Onbekend'
    let updated_at_short = {
      date: '',
      short: ''
    }
    let updated_at_nr = data.updated_at || data.ts || 0

    if (data.updated_at || data.ts) {

      let recordDate = new Date(updated_at_nr)
      updated_at = `${recordDate.toLocaleDateString('nl-NL')} ${formatTime(recordDate)}`

      // old data
      updated_at_short = {
        date: recordDate.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: '2-digit' }).replace('. ', ' \''),
        time: formatTime(recordDate),
      }
      // if (currentYear > recordDate.getFullYear()) {
      //   updated_at_short = recordDate.toLocaleDateString("nl-NL", { day: 'numeric', month: 'short', year: 'numeric' })
      // } else {

      // }
    }
    // console.log(data.Locations)
    // The first Location is the current Location
    const CurrentLocation = data.data

    try {
      let status = data.status ? data.status : null

      status = {
        // TODO: CBAPI - DEFERRED - Move these to flow state ... 
        step: status?.step,
        uuid: status?.uuid,
        version: status?.version || 1,
        label: status?.label || '', // TODO: CBAPI - DEFERRED - remove ?

        // Actual state 
        // TODO: CBAPI - DEFERRED - add access methods & switch to CBAPI format
        completed: !! status?.completed?.enabled,
        cancelled: !! status?.cancelled?.enabled,
        onhold: !! status?.onhold?.enabled,
        vkb: !! status?.vkb?.enabled,
        gdpr: !! status?.gdpr?.enabled,
      }

      // Go by process flow
      if (data.flow) {
        // console.log("flow available... !", data.flow, ref)

        status = Object.assign(
          status,
          this.CBAPIstatusByFlow({ flow: data.flow }),
        )
        // console.log(status)
      }

      // console.log("status", this.CBAPIstatusByFlow({
      //   flow: data.flow
      // }))

      let statusMetaDefaults = {
        onhold: {
          reason: '',
          label: '',
          comment: '',
        },
        cancelled: {
          reason: '',
          label: '',
          comment: '',
        },
        onholdReason: '',
        onholdLabel: '',
        onholdComment: '',
        cancelledReason: '',
        cancelledLabel: '',
        cancelledComment: '',
      }
      let statusMeta = statusMetaDefaults

      // Merge status details 
      statusMeta = Object.assign(
        statusMetaDefaults, 
        (data.statusMeta || {}),
        (data.status || {})
      )
      
      if (CurrentLocation) {
        //console.log(data)
        CurrentLocation.Municipality = data.MunicipalityCode || data.Municipality || null
        CurrentLocation.MunicipalityCode = CurrentLocation.Municipality
      }

      // TODO - DEN HARTOG - Rename Location Model to Iteration
      const IterationInstance = CurrentLocation 
        ? new Location({ data: CurrentLocation }) 
        : new Location({ data: {} })


      model = {
        cbapi: true,
        ref: null, // TODO: CBAPI - TEST - check for dependency on this variable
        uuid: data.uuid,
        ts: data.ts || null,
        ts_readable: data.ts_readable || null,

        processType: data?.type?.sub || null,

        case_ref: data.reference || '',
        case_counter: data.caseNumber || 0,

        status,
        statusMeta,

        stakeholders: data.stakeholders || [],

        /**
         * Step 1 only for now
         */
        values: {
          Location: IterationInstance
        },

        CurrentLocation,

        // TODO: CBAPI - TEST - Does using a reference instead of a new model instance affect the way iterations work ?
        history: [
          IterationInstance
        ],

        // TODO: CBAPI - FILES - cleanup 
        Docs: {
          ParkingSpots: [],
          Underground: [],
          Broker: [],
          GridOperator: [],
          CPOAdditional: [],
          TrafficDecision: [],
          DeliveryDocumentation: [],
          SideView: [],
          TopView: [],
        },

        /**
         * CBAPI Style file information
         *  Don't go through a reduce method untill called upon
         */
        Files: data.files || [],
        OrderedFiles: null,

        /**
         * Connected requests
         */
        requestUuids: data.requests || [],
        relationalChanges: {
          removed: [],
          added: [],
        },

        /**
         * Location connections
         */
        connectedLocations: data.locations || {},

        /**
         * Tags
         */
        Tags: data.tags || [],

        /**
         * Calculated based on events
         */
        processDurationByStep: {},

        /**
         * Comments
         */
        comments: data.comments || [],

        /**
         * The process flow information
         */
        flow: data.flow || null,

        updated_at,
        updated_at_short,
        updated_at_nr,

        created_at: data.created_at || null
      }
      //console.log(model.values)
      model.processDurationByStep = this.CBAPIcalculateStepDuractions({ 
        flowState: data?.flow?.state || []
      })


      model.Municipality = this.generateMunicipalityData({ model, data })
      model.MunicipalityCode = model.Municipality
      model.address = this.generateAddressData({ model, data })

    } catch (e) {
      console.log(e)
      console.log('Failed to construct data model')
    }

    return model
  }
}



/******************************************************************************
 * CBAPI Location 
 */
if (! Realisation.prototype.getCBAPICoordinates) {
  Realisation.prototype.getCBAPICoordinates = function() {
    if (this.cbapi && this.connectedLocations?.selected) {
      let location = this.$store.getters['chargingpoints/getChargingPointByUUID']({
        uuid: this.connectedLocations.selected?.locationUuid,
      })
      if (location && location.isCBAPI()) {
        return location.getCoordinates()
      }
    }
    return {
      lat: null,
      lng: null
    }
  }
}



/******************************************************************************
 * Status getters
 */
if (! Realisation.prototype.getStatus) {
  Realisation.prototype.getStatus = function({ name }) {
    return Object.prototype.hasOwnProperty.call(this.status, name)
      ? !! this.status[name]
      : null
  }
}
if (! Realisation.prototype.getStatusMeta) {
  Realisation.prototype.getStatusMeta = function({ name }) {
    return this.statusMeta[name] || {}
  }
}
if (! Realisation.prototype.isCancelled) {
  Realisation.prototype.isCancelled = function() {
    return !! this.status.cancelled
  }
}
if (! Realisation.prototype.isCompleted) {
  Realisation.prototype.isCompleted = function() {
    return !! this.status.completed
  }
}
if (! Realisation.prototype.isOnHold) {
  Realisation.prototype.isOnHold = function() {
    return !! this.status.onhold
  }
}
if (! Realisation.prototype.isLocked) {
  Realisation.prototype.isLocked = function() {
    return !! this.status.locked
  }
}


/******************************************************************************
 * File getters
 */

/**
 * Order files by category
 *  This is done upon demand, to avoid running reduce for no reason at all
 */
Realisation.prototype.processFileData = function() {
  this.OrderedFiles = (this.Files ||[]).reduce((acc, file) => {
    let category = file.category
    acc[category] = acc[category] || []
    acc[category].push(file)
    return acc
  }, {}) 
}


Realisation.prototype.hasFileOfCategory = function({ category }) {
  if (this.OrderedFiles === null) {
    this.processFileData()
  }

  return (this.OrderedFiles[category] || []).length !== 0
}

Realisation.prototype.getFileDataByCategory = function({ category }) {
  if (this.OrderedFiles === null) {
    this.processFileData()
  }
  return (this.OrderedFiles[category] || [])
}


export default Realisation
